<!-- ══════════════════════════════════════════════════════
     BEE-KIDS | Landing Page – Premium Redesign
     Dynamic Branding via CSS variables on :host
══════════════════════════════════════════════════════ -->

<!-- ═══ NAVBAR ═══ -->
<nav class="bk-nav" id="bk-navbar">
  <div class="bk-nav__brand">
    <img src="../../../../../assets/img/monkey.png" alt="Bee-Kids Logo" class="bk-nav__logo">
    <div class="bk-nav__name">
      <span class="bk-nav__name--primary">BEE</span><span class="bk-nav__name--accent">-KIDS</span>
    </div>
  </div>

  <div class="bk-nav__center" [routerLink]="['beekids/accueil']" style="cursor: pointer;">
    <div class="bk-nav__kiosk">
      <span class="bk-nav__tagline--1">{{ 'NAV.KINDERGARTEN' | translate }}</span>
      <span class="bk-nav__tagline--2">{{ 'NAV.CHILDREN' | translate }}</span>
    </div>
  </div>

  <div class="bk-nav__actions">
    <button class="bk-btn bk-btn--outline" data-bs-toggle="modal" data-bs-target="#loginModal" id="nav-login-btn">
      <i class="fas fa-sign-in-alt"></i> {{ 'NAV.LOGIN' | translate }}
    </button>

    <div class="bk-lang">
      <select class="bk-lang__select" (change)="switchLang($event)" id="language-switcher">
        <option value="fr">🇫🇷 Français</option>
        <option value="en">🇬🇧 English</option>
        <option value="ar">🇹🇳 العربية</option>
      </select>
      <i class="fas fa-globe bk-lang__icon"></i>
    </div>
  </div>

  <!-- Mobile hamburger -->
  <button class="bk-nav__burger" id="nav-burger" (click)="toggleMenu()">
    <span></span><span></span><span></span>
  </button>
</nav>

<!-- Mobile Menu Drawer -->
<div class="bk-mobile-menu" id="bk-mobile-menu">
  <button class="bk-btn bk-btn--primary w-100 mb-2" data-bs-toggle="modal" data-bs-target="#loginModal">
    <i class="fas fa-school"></i> {{ 'HOME.LOGIN_ESTABLISHMENT' | translate }}
  </button>
  <div class="bk-mobile-roles">
    <button class="bk-role-btn" data-bs-toggle="modal" data-bs-target="#loginModal">
      <i class="fas fa-user-graduate"></i> {{ 'HOME.ROLE_EDUCATORS' | translate }}
    </button>
    <button class="bk-role-btn" data-bs-toggle="modal" data-bs-target="#loginModal">
      <i class="fas fa-users"></i> {{ 'HOME.ROLE_PARENTS' | translate }}
    </button>
    <button class="bk-role-btn" data-bs-toggle="modal" data-bs-target="#loginModal">
      <i class="fas fa-user-tie"></i> {{ 'HOME.ROLE_DIRECTORS' | translate }}
    </button>
  </div>
  <div class="bk-mobile-stores mt-3">
    <button class="bk-store-btn" data-bs-toggle="modal" data-bs-target="#PlayStore">
      <i class="fab fa-google-play"></i> {{ 'HOME.PLAY_STORE' | translate }}
    </button>
    <button class="bk-store-btn" data-bs-toggle="modal" data-bs-target="#AppStore">
      <i class="fab fa-apple"></i> {{ 'HOME.APP_STORE' | translate }}
    </button>
  </div>
</div>

<!-- Login Modal -->
<app-login></app-login>

<!-- ═══ HERO SECTION ═══ -->
<section class="bk-hero" id="hero">
  <!-- animated wave background -->
  <div class="bk-hero__wave-bg">
    <svg viewBox="0 0 1440 700" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
      <path class="wave-path wave-path--1" d="M0,200 C200,100 400,300 600,200 C800,100 1000,300 1200,200 C1350,130 1420,180 1440,160 L1440,0 L0,0 Z"/>
      <path class="wave-path wave-path--2" d="M0,280 C250,160 450,360 700,260 C900,180 1100,340 1300,240 C1380,200 1430,240 1440,230 L1440,0 L0,0 Z" opacity="0.5"/>
    </svg>
  </div>

  <!-- Floating decorative elements -->
  <div class="bk-hero__deco bk-hero__deco--cube bk-hero__deco--1">
    <span>A</span>
  </div>
  <div class="bk-hero__deco bk-hero__deco--cube bk-hero__deco--2">
    <span>B</span>
  </div>
  <div class="bk-hero__deco bk-hero__deco--cube bk-hero__deco--3">
    <span>C</span>
  </div>
  <div class="bk-hero__deco bk-hero__deco--circle bk-hero__deco--4"></div>
  <div class="bk-hero__deco bk-hero__deco--circle bk-hero__deco--5"></div>
  <div class="bk-hero__deco bk-hex bk-hex--1"></div>
  <div class="bk-hero__deco bk-hex bk-hex--2"></div>

  <div class="bk-hero__content">
    <!-- Left: Text -->
    <div class="bk-hero__text" data-aos="fade-right">
      <div class="bk-hero__badge">
        <i class="fas fa-star"></i> {{ 'HOME.BADGE_TEXT' | translate }}
      </div>
      <h1 class="bk-hero__title">
        {{ 'HOME.HERO_TITLE' | translate }}
        <span class="bk-hero__title--accent">{{ 'HOME.HERO_TITLE_ACCENT' | translate }}</span>
      </h1>
      <p class="bk-hero__subtitle">
        {{ 'HOME.HERO_SUBTITLE' | translate }}
      </p>

      <button class="bk-btn bk-btn--primary bk-btn--lg mb-4" data-bs-toggle="modal" data-bs-target="#loginModal" id="hero-login-btn">
        <i class="fas fa-door-open"></i> {{ 'HOME.LOGIN_BTN' | translate }}
      </button>

      <ul class="bk-hero__checklist">
        <li><i class="fas fa-check-circle"></i> {{ 'HOME.CHECKLIST_1' | translate }}</li>
        <li><i class="fas fa-check-circle"></i> {{ 'HOME.CHECKLIST_2' | translate }}</li>
        <li><i class="fas fa-check-circle"></i> {{ 'HOME.CHECKLIST_3' | translate }}</li>
        <li><i class="fas fa-check-circle"></i> {{ 'HOME.CHECKLIST_4' | translate }}</li>
      </ul>

      <div class="bk-hero__stores">
        <button class="bk-store-btn bk-store-btn--dark" data-bs-toggle="modal" data-bs-target="#PlayStore" id="play-store-btn">
          <i class="fab fa-google-play"></i>
          <span><small>{{ 'HOME.AVAILABLE_ON' | translate }}</small><br>{{ 'HOME.PLAY_STORE' | translate }}</span>
        </button>
        <button class="bk-store-btn bk-store-btn--dark" data-bs-toggle="modal" data-bs-target="#AppStore" id="app-store-btn">
          <i class="fab fa-apple"></i>
          <span><small>{{ 'HOME.DOWNLOAD_ON' | translate }}</small><br>{{ 'HOME.APP_STORE' | translate }}</span>
        </button>
      </div>
    </div>

    <!-- Right: Hero Image -->
    <div class="bk-hero__image-wrap" data-aos="fade-left">
      <div class="bk-hero__img-card">
        <img src="../../../../../assets/img/enfant.png" alt="Enfants apprenant avec Bee-Kids" class="bk-hero__img">
        <!-- Floating stat cards -->
        <div class="bk-stat-card bk-stat-card--tl">
          <i class="fas fa-child"></i>
          <div><strong>+2 500</strong><br><small>{{ 'HOME.CHILDREN_TRACKED' | translate }}</small></div>
        </div>
        <div class="bk-stat-card bk-stat-card--br">
          <i class="fas fa-school"></i>
          <div><strong>150+</strong><br><small>{{ 'HOME.ESTABLISHMENTS_TRACKED' | translate }}</small></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Scroll cue -->
  <a (click)="scrollToFeatures()" class="bk-scroll-cue" style="cursor: pointer;">
    <span>{{ 'HOME.DISCOVER' | translate }}</span>
    <div class="bk-scroll-cue__arrow"></div>
  </a>
</section>

<!-- ═══ FEATURE CARDS ═══ -->
<section class="bk-features" id="features">
  <div class="bk-section-header">
    <span class="bk-label">{{ 'HOME.FEATURES_LABEL' | translate }}</span>
    <h2>{{ 'HOME.FEATURES_TITLE' | translate }} <span class="bk-accent">{{ 'HOME.FEATURES_TITLE_ACCENT' | translate }}</span></h2>
    <p>{{ 'HOME.FEATURES_SUBTITLE' | translate }}</p>
  </div>

  <div class="bk-features__grid">
    <!-- Card 1 -->
    <div class="bk-feature-card" id="feature-admin">
      <div class="bk-feature-card__icon-wrap bk-feature-card__icon-wrap--admin">
        <i class="fas fa-clipboard-list"></i>
      </div>
      <h3>{{ 'HOME.FEATURE_1_TITLE' | translate }} <span class="bk-accent">{{ 'HOME.FEATURE_1_TITLE_ACCENT' | translate }}</span></h3>
      <p>{{ 'HOME.FEATURE_1_DESC' | translate }}</p>
      <ul class="bk-feature-card__list">
        <li><i class="fas fa-check"></i> {{ 'HOME.FEATURE_1_BULLET_1' | translate }}</li>
        <li><i class="fas fa-check"></i> {{ 'HOME.FEATURE_1_BULLET_2' | translate }}</li>
        <li><i class="fas fa-check"></i> {{ 'HOME.FEATURE_1_BULLET_3' | translate }}</li>
      </ul>
    </div>

    <!-- Card 2 -->
    <div class="bk-feature-card bk-feature-card--featured" id="feature-comm">
      <div class="bk-feature-card__badge">{{ 'HOME.POPULAR' | translate }}</div>
      <div class="bk-feature-card__icon-wrap bk-feature-card__icon-wrap--comm">
        <i class="fas fa-comments"></i>
      </div>
      <h3>{{ 'HOME.FEATURE_2_TITLE' | translate }} <span class="bk-accent">{{ 'HOME.FEATURE_2_TITLE_ACCENT' | translate }}</span></h3>
      <p>{{ 'HOME.FEATURE_2_DESC' | translate }}</p>
      <ul class="bk-feature-card__list">
        <li><i class="fas fa-check"></i> {{ 'HOME.FEATURE_2_BULLET_1' | translate }}</li>
        <li><i class="fas fa-check"></i> {{ 'HOME.FEATURE_2_BULLET_2' | translate }}</li>
        <li><i class="fas fa-check"></i> {{ 'HOME.FEATURE_2_BULLET_3' | translate }}</li>
      </ul>
    </div>

    <!-- Card 3 -->
    <div class="bk-feature-card" id="feature-suivi">
      <div class="bk-feature-card__icon-wrap bk-feature-card__icon-wrap--dev">
        <i class="fas fa-chart-line"></i>
      </div>
      <h3>{{ 'HOME.FEATURE_3_TITLE' | translate }} <span class="bk-accent">{{ 'HOME.FEATURE_3_TITLE_ACCENT' | translate }}</span></h3>
      <p>{{ 'HOME.FEATURE_3_DESC' | translate }}</p>
      <ul class="bk-feature-card__list">
        <li><i class="fas fa-check"></i> {{ 'HOME.FEATURE_3_BULLET_1' | translate }}</li>
        <li><i class="fas fa-check"></i> {{ 'HOME.FEATURE_3_BULLET_2' | translate }}</li>
        <li><i class="fas fa-check"></i> {{ 'HOME.FEATURE_3_BULLET_3' | translate }}</li>
      </ul>
    </div>
  </div>
</section>

<!-- ═══ ECOSYSTEM / ESTABLISHMENT SHOWCASE ═══ -->
<section class="bk-ecosystem" id="ecosystem">
  <div class="bk-ecosystem__bg-deco"></div>
  <div class="bk-section-header bk-section-header--light">
    <span class="bk-label bk-label--light">{{ 'HOME.ESTAB_SECTION_LABEL' | translate }}</span>
    <h2>{{ 'HOME.ESTAB_SECTION_TITLE' | translate }} <span class="bk-accent--light">{{ 'HOME.ESTAB_SECTION_TITLE_ACCENT' | translate }}</span></h2>
  </div>

  <div class="bk-estab-carousel">
    <div class="bk-estab-track" id="bk-estab-track">
      <!-- ✅ Affichage dynamique des établissements -->
      <div class="bk-estab-card"
           *ngFor="let estab of establishments; let i = index"
           [style.--estab-color]="estab.primaryColor || '#3D6461'">
        <div class="bk-estab-card__logo-wrap">
          <img [src]="getLogoUrl(estab.logoUrl)"
               [alt]="estab.nom"
               (error)="$any($event.target).src = defaultLogo">
        </div>
        <div class="bk-estab-card__color-dot"
             [style.background]="estab.primaryColor || '#3D6461'"></div>
        <p>{{ estab.nom }}</p>
      </div>

      <!-- ✅ Message si aucun établissement -->
      <div class="bk-estab-card" *ngIf="establishments.length === 0" style="--estab-color: #6b7280;">
        <div class="bk-estab-card__logo-wrap">
          <img src="../../../../../assets/img/monkey.png" alt="Logo par défaut">
        </div>
        <div class="bk-estab-card__color-dot" style="background:#6b7280;"></div>
        <p>{{ 'HOME.NO_ESTABLISHMENTS' | translate }}</p>
      </div>
    </div>
    <button class="bk-carousel-btn bk-carousel-btn--prev" id="carousel-prev">&#8249;</button>
    <button class="bk-carousel-btn bk-carousel-btn--next" id="carousel-next">&#8250;</button>
  </div>

  <div class="bk-ecosystem__cta">
    <button class="bk-btn bk-btn--primary bk-btn--lg" data-bs-toggle="modal" data-bs-target="#loginModal" id="ecosystem-login-btn">
      <i class="fas fa-sign-in-alt"></i> {{ 'HOME.LOGIN_BTN' | translate }}
    </button>
  </div>
</section>

<!-- ═══ TESTIMONIAL ═══ -->
<section class="bk-testimonials" id="testimonials">
  <div class="bk-section-header">
    <span class="bk-label">{{ 'HOME.TESTIMONIALS_LABEL' | translate }}</span>
    <h2>{{ 'HOME.TESTIMONIALS_TITLE' | translate }} <span class="bk-accent">{{ 'HOME.TESTIMONIALS_TITLE_ACCENT' | translate }}</span></h2>
  </div>

  <div class="bk-testimonials__grid">
    <div class="bk-testimonial-card" id="testimonial-sebastien">
      <div class="bk-testimonial-card__quote">"</div>
      <p class="bk-testimonial-card__text">
        {{ 'HOME.TESTIMONIAL_1_QUOTE' | translate }}
      </p>
      <div class="bk-testimonial-card__author">
        <div class="bk-testimonial-card__avatar">
          <img src="../../../../../assets/img/image2.png" alt="Amina">
        </div>
        <div class="bk-testimonial-card__info">
          <strong>{{ 'HOME.TESTIMONIAL_1_NAME' | translate }}</strong>
          <span>{{ 'HOME.TESTIMONIAL_1_ROLE' | translate }}</span>
          <div class="bk-stars">
            <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="bk-testimonial-card" id="testimonial-2">
      <div class="bk-testimonial-card__quote">"</div>
      <p class="bk-testimonial-card__text">
        {{ 'HOME.TESTIMONIAL_2_QUOTE' | translate }}
      </p>
      <div class="bk-testimonial-card__author">
        <div class="bk-testimonial-card__avatar">
          <img src="../../../../../assets/img/image1.png" alt="User">
        </div>
        <div class="bk-testimonial-card__info">
          <strong>{{ 'HOME.TESTIMONIAL_2_NAME' | translate }}</strong>
          <span>{{ 'HOME.TESTIMONIAL_2_ROLE' | translate }}</span>
          <div class="bk-stars">
            <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ═══ MAP / LOCATION ═══ -->
<section class="bk-location" id="location">
  <div class="bk-section-header">
    <span class="bk-label">{{ 'HOME.MAP_LABEL' | translate }}</span>
    <h2>{{ 'HOME.MAP_TITLE' | translate }} <span class="bk-accent">{{ 'HOME.MAP_TITLE_ACCENT' | translate }}</span></h2>
    <p>{{ 'HOME.MAP_SUBTITLE' | translate }}</p>
  </div>

  <div class="bk-location__content">
    <div class="bk-location__map-wrap">
      <div class="bk-location__map-placeholder">
        <div class="bk-map-pin">
          <i class="fas fa-map-marker-alt"></i>
        </div>
        <div class="bk-map-pulse"></div>
        <p class="bk-map-label">Tunisie — Siège Social BEE-KIDS</p>
      </div>
    </div>
    <div class="bk-location__info">
      <div class="bk-location__info-item">
        <i class="fas fa-map-marker-alt"></i>
        <div>
          <strong>{{ 'HOME.LOCATION.ADDRESS_LBL' | translate }}</strong>
          <p>{{ 'HOME.LOCATION.ADDRESS_VAL' | translate }}</p>
        </div>
      </div>
      <div class="bk-location__info-item">
        <i class="fas fa-envelope"></i>
        <div>
          <strong>{{ 'HOME.LOCATION.EMAIL_LBL' | translate }}</strong>
          <p>contact&#64;beekids.tn</p>
        </div>
      </div>
      <div class="bk-location__info-item">
        <i class="fas fa-phone"></i>
        <div>
          <strong>{{ 'HOME.LOCATION.PHONE_LBL' | translate }}</strong>
          <p>+216 29 370 239</p>
        </div>
      </div>
      <button class="bk-btn bk-btn--primary mt-3" data-bs-toggle="modal" data-bs-target="#localisation" id="location-btn">
        <i class="fas fa-qrcode"></i> {{ 'HOME.SEE_LOCATION' | translate }}
      </button>
    </div>
  </div>
</section>

<!-- ═══ CTA BANNER ═══ -->
<section class="bk-cta-banner" id="cta-banner">
  <div class="bk-cta-banner__bg">
    <div class="bk-cta-banner__orb bk-cta-banner__orb--1"></div>
    <div class="bk-cta-banner__orb bk-cta-banner__orb--2"></div>
  </div>
  <div class="bk-cta-banner__content">
    <img src="../../../../../assets/img/monkey.png" alt="Bee-Kids" class="bk-cta-banner__logo">
    <div class="bk-cta-banner__text">
      <h2>{{ 'HOME.CTA_TITLE' | translate }}<br><strong>{{ 'HOME.CTA_TITLE_ACCENT' | translate }}</strong></h2>
      <p>{{ 'HOME.CTA_SUBTITLE' | translate }}</p>
    </div>
    <div class="bk-cta-banner__actions">
      <button class="bk-btn bk-btn--white" data-bs-toggle="modal" data-bs-target="#loginModal" id="cta-login-btn">
        <i class="fas fa-sign-in-alt"></i> {{ 'HOME.LOGIN_ESTABLISHMENT' | translate }}
      </button>
      <div class="bk-cta-banner__stores">
        <button class="bk-store-btn bk-store-btn--outline" data-bs-toggle="modal" data-bs-target="#PlayStore">
          <i class="fab fa-google-play"></i> {{ 'HOME.PLAY_STORE' | translate }}
        </button>
        <button class="bk-store-btn bk-store-btn--outline" data-bs-toggle="modal" data-bs-target="#AppStore">
          <i class="fab fa-apple"></i> {{ 'HOME.APP_STORE' | translate }}
        </button>
      </div>
    </div>
  </div>
</section>

<!-- ═══ DEMO VIDEO ═══ -->
<section class="bk-demo" id="demo-video">
  <div class="bk-demo__content">
    <div class="bk-demo__text">
      <span class="bk-demo__badge">DEMO</span>
      <h2>Decouvrez BeeKids en video</h2>
      <p>Regardez notre video de demonstration pour decouvrir toutes les fonctionnalites de la plateforme BeeKids : processus d'inscription, gestion des classes, suivi pedagogique, paiement en ligne et bien plus encore.</p>
      <div class="bk-demo__steps">
        <div class="bk-demo__step">
          <div class="bk-demo__step-icon"><i class="fas fa-shopping-cart"></i></div>
          <div>
            <strong>Processus de vente</strong>
            <span>De la creation du compte a la souscription</span>
          </div>
        </div>
        <div class="bk-demo__step">
          <div class="bk-demo__step-icon"><i class="fas fa-credit-card"></i></div>
          <div>
            <strong>Paiement en ligne</strong>
            <span>Paiement securise via Flouci</span>
          </div>
        </div>
        <div class="bk-demo__step">
          <div class="bk-demo__step-icon"><i class="fas fa-chalkboard-teacher"></i></div>
          <div>
            <strong>Services proposes</strong>
            <span>Suivi, messagerie, presences, menus</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bk-demo__video">
      <div class="bk-demo__video-wrapper">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/VIDEO_ID" title="BeeKids Demo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <p class="bk-demo__video-caption">Video de demonstration de la plateforme BeeKids</p>
    </div>
  </div>
</section>

<!-- ═══ CONTACT SECTION ═══ -->
<section class="bk-contact" id="contact">
  <div class="bk-section-header">
    <span class="bk-label">Contact</span>
    <h2>Une question ? <span class="bk-accent">Contactez-nous</span></h2>
    <p>Notre equipe est la pour vous repondre dans les plus brefs delais.</p>
  </div>

  <div class="bk-contact__content">
    <div class="bk-contact__info">
      <div class="bk-contact__info-item">
        <i class="fas fa-map-marker-alt"></i>
        <div>
          <strong>Adresse</strong>
          <p>Tunis, Tunisie</p>
        </div>
      </div>
      <div class="bk-contact__info-item">
        <i class="fas fa-envelope"></i>
        <div>
          <strong>Email</strong>
          <p>contact&#64;beekids.tn</p>
        </div>
      </div>
      <div class="bk-contact__info-item">
        <i class="fas fa-phone"></i>
        <div>
          <strong>Telephone</strong>
          <p>+216 29 370 239</p>
        </div>
      </div>
    </div>

    <form class="bk-contact__form" (ngSubmit)="submitContact()" #contactForm="ngForm">
      <div *ngIf="contactSuccess" class="bk-contact__success">
        <i class="fas fa-check-circle"></i> {{ contactSuccess }}
      </div>
      <div *ngIf="contactError" class="bk-contact__error">
        <i class="fas fa-exclamation-circle"></i> {{ contactError }}
      </div>

      <div class="bk-contact__row">
        <div class="bk-contact__field">
          <label for="contact-nom">Nom complet *</label>
          <input id="contact-nom" type="text" class="bk-contact__input" [(ngModel)]="contactData.nom" name="nom" required placeholder="Votre nom">
        </div>
        <div class="bk-contact__field">
          <label for="contact-email">Email *</label>
          <input id="contact-email" type="email" class="bk-contact__input" [(ngModel)]="contactData.email" name="email" required placeholder="votre&#64;email.com">
        </div>
      </div>

      <div class="bk-contact__field">
        <label for="contact-sujet">Sujet *</label>
        <input id="contact-sujet" type="text" class="bk-contact__input" [(ngModel)]="contactData.sujet" name="sujet" required placeholder="Sujet de votre message">
      </div>

      <div class="bk-contact__field">
        <label for="contact-message">Message *</label>
        <textarea id="contact-message" class="bk-contact__textarea" [(ngModel)]="contactData.message" name="message" required placeholder="Votre message..." rows="5"></textarea>
      </div>

      <button type="submit" class="bk-btn bk-btn--primary bk-btn--lg" [disabled]="contactSending">
        <i class="fas fa-paper-plane"></i> {{ contactSending ? 'Envoi en cours...' : 'Envoyer le message' }}
      </button>
    </form>
  </div>
</section>

<!-- ═══ FOOTER ═══ -->
<footer class="bk-footer" id="main-footer">
  <div class="bk-footer__top">
    <div class="bk-footer__brand">
      <img src="../../../../../assets/img/monkey.png" alt="Bee-Kids" class="bk-footer__logo">
      <div>
        <div class="bk-footer__brand-name">
          <span>BEE</span><span class="bk-footer__brand-accent">-KIDS</span>
        </div>
        <p class="bk-footer__tagline">{{ 'HOME.FOOTER.TAGLINE' | translate }}</p>
      </div>
    </div>

    <div class="bk-footer__links">
      <div class="bk-footer__col">
        <h4>{{ 'HOME.FOOTER.PLATFORM_H' | translate }}</h4>
        <a (click)="scrollToFeatures()" style="cursor: pointer;">{{ 'HOME.FOOTER.FEATURES' | translate }}</a>
        <a href="#ecosystem">{{ 'HOME.FOOTER.ESTAB' | translate }}</a>
        <a href="#testimonials">{{ 'HOME.FOOTER.TESTIMONIALS' | translate }}</a>
        <a href="#location">{{ 'HOME.FOOTER.LOCATION' | translate }}</a>
      </div>
      <div class="bk-footer__col">
        <h4>{{ 'HOME.FOOTER.LOGIN_H' | translate }}</h4>
        <a href="#" data-bs-toggle="modal" data-bs-target="#loginModal">{{ 'HOME.FOOTER.DIRECTOR' | translate }}</a>
        <a href="#" data-bs-toggle="modal" data-bs-target="#loginModal">{{ 'HOME.FOOTER.EDUCATOR' | translate }}</a>
        <a href="#" data-bs-toggle="modal" data-bs-target="#loginModal">{{ 'HOME.FOOTER.PARENT' | translate }}</a>
      </div>
      <div class="bk-footer__col">
        <h4>{{ 'HOME.FOOTER.APP_H' | translate }}</h4>
        <a href="#" data-bs-toggle="modal" data-bs-target="#PlayStore">
          <i class="fab fa-google-play"></i> {{ 'HOME.PLAY_STORE' | translate }}
        </a>
        <a href="#" data-bs-toggle="modal" data-bs-target="#AppStore">
          <i class="fab fa-apple"></i> {{ 'HOME.APP_STORE' | translate }}
        </a>
      </div>
      <div class="bk-footer__col">
        <h4>{{ 'HOME.FOOTER.LANG_H' | translate }}</h4>
        <div class="bk-lang">
          <select class="bk-lang__select" (change)="switchLang($event)" id="footer-language-switcher">
            <option value="fr">🇫🇷 Français</option>
            <option value="en">🇬🇧 English</option>
            <option value="ar">🇹🇳 العربية</option>
          </select>
          <i class="fas fa-globe bk-lang__icon"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="bk-footer__bottom">
    <p>{{ 'FOOTER.COPYRIGHT' | translate }}</p>
    <div class="bk-footer__legal">
      <a routerLink="/mentions-legales">{{ 'HOME.FOOTER_LEGAL' | translate }}</a>
      <a routerLink="/confidentialite">{{ 'HOME.FOOTER_PRIVACY' | translate }}</a>
      <a routerLink="/cgv">CGV</a>
    </div>
    <p class="bk-footer__platform">{{ 'HOME.FOOTER.TAGLINE' | translate }}</p>
  </div>
</footer>

<!-- ══════════════════════════════════
     MODALS
══════════════════════════════════ -->

<!-- Play Store Modal -->
<div class="modal fade" id="PlayStore" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="display: flex; align-items: center; min-height: 100vh; margin: 0 auto; justify-content: center;">
    <div class="modal-content bk-modal">
      <button type="button" class="bk-modal__close" data-bs-dismiss="modal">×</button>
      <h2 class="bk-modal__title">{{ 'HOME.QR_PLAY' | translate }}</h2>
      <div class="bk-modal__body text-center">
        <a href="https://play.google.com/store/apps/details?id=com.beeKids.BeeKIDS" target="_blank" rel="noopener noreferrer">
          <img src="../../../../../assets/img/playstore.png" alt="QR Play Store" class="bk-modal__qr">
        </a>
        <p class="bk-modal__direct-link mt-3">
          <a href="https://play.google.com/store/apps/details?id=com.beeKids.BeeKIDS" target="_blank" rel="noopener noreferrer" class="bk-store-link">
            <i class="fab fa-google-play"></i> {{ 'HOME.PLAY_STORE' | translate }}
          </a>
        </p>
      </div>
    </div>
  </div>
</div>

<!-- App Store Modal -->
<div class="modal fade" id="AppStore" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="display: flex; align-items: center; min-height: 100vh; margin: 0 auto; justify-content: center;">
    <div class="modal-content bk-modal">
      <button type="button" class="bk-modal__close" data-bs-dismiss="modal">×</button>
      <h2 class="bk-modal__title">{{ 'HOME.QR_APP' | translate }}</h2>
      <div class="bk-modal__body text-center">
        <a href="https://apps.apple.com/fr/app/bee-kids/id6755379519" target="_blank" rel="noopener noreferrer">
          <img src="../../../../../assets/img/Untitled.jpeg" alt="QR App Store" class="bk-modal__qr">
        </a>
        <p class="bk-modal__direct-link mt-3">
          <a href="https://apps.apple.com/fr/app/bee-kids/id6755379519" target="_blank" rel="noopener noreferrer" class="bk-store-link">
            <i class="fab fa-apple"></i> {{ 'HOME.APP_STORE' | translate }}
          </a>
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Localisation Modal -->
<div class="modal fade" id="localisation" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" style="display: flex; align-items: center; min-height: 100vh; margin: 0 auto; justify-content: center;">
    <div class="modal-content bk-modal">
      <button type="button" class="bk-modal__close" data-bs-dismiss="modal">×</button>
      <h2 class="bk-modal__title">{{ 'HOME.QR_LOCATION' | translate }}</h2>
      <div class="bk-modal__body text-center">
        <img src="../../../../../assets/img/bing_generated_qrcode (1).png" alt="QR Localisation" class="bk-modal__qr">
      </div>
    </div>
  </div>
</div>